// @flow

import type {Tracking} from "../../models/Tracking";
import type {Product} from "../../models/Product";
import type {Item} from "../../models/Item";
import type {OrderReducerState} from "../../reducers/orderReducer";
import type {CouponReducerState} from "../../reducers/couponReducer";

/**
 * No-op base implementation of the Tracking interface. Concrete trackers
 * (Google, GTM, Piwik, eTracker) only override the hooks they support.
 */
export default class BaseTracker implements Tracking {
	useEcommerce: boolean;
	trackingId: string;

	constructor(trackingId: string, withEcommerce: boolean) {
		this.useEcommerce = withEcommerce;
		this.trackingId = trackingId;
	}

	setEcommerce = (value: boolean) => {
		this.useEcommerce = value;
	};

	/* eslint-disable no-unused-vars */
	logOrder(order: OrderReducerState, coupon: ?CouponReducerState): void {
	}

	addItem(product: Product, amount: number): void {
	}

	removeItem(product: Product, amount: number): void {
	}

	clearCart(): void {
	}

	showProductDetails(product: Product): void {
	}

	insertToWatchlist(product: Product): void {
	}

	removeFromWatchlist(product: Product): void {
	}

	logSearch(searchPhrase: string): void {
	}

	logShare(product: Product): void {
	}

	logSelectContent(contentType: string, contentId: string): void {
	}

	logGenerateLead(products: Product[], leadSource: string): void {
	}

	logViewCart(items: Item[]): void {
	}

	logBeginCheckout(items: Item[], coupon: ?CouponReducerState): void {
	}

	logAddShippingInfo(items: Item[], coupon: ?CouponReducerState): void {
	}

	logAddPaymentInfo(items: Item[], coupon: ?CouponReducerState, paymentType: ?string): void {
	}
	/* eslint-enable no-unused-vars */
}
